import React, { useRef, useEffect } from "react"
import { Dialog, HeaderBar, Content } from "./styles"
import CloseIcon from "../close-icon"
import { H1 } from "../typography"
import PropTypes from "prop-types"
const Modal = ({ isOpen, hasCloseBtn, onClose, children, header, employerTile }) => {
  const dialogRef = useRef(null)

  useEffect(() => {
    if (isOpen) {
      dialogRef.current.showModal() // Opens the dialog as a modal
    } else {
      dialogRef.current.close() // Closes the dialog
    }
  }, [isOpen])

  const handleCloseModal = () => {
    if (onClose) onClose()

    dialogRef.current.close() // Ensure the dialog is closed
    return true
  }

  const handleKeyDown = (event) => {
    if (event.key === "Escape") handleCloseModal()
  }

  const isClickInsideDialog = (e, element) => {
    const r = element.getBoundingClientRect()
    const isInside = e.clientX > r.left && e.clientX < r.right && e.clientY > r.top && e.clientY < r.bottom // Are we clicking inside the dialog?

    return isInside
  }

  const dialogClickHandler = (e) => {
    if (e.target.classList.contains("close-icon") || e.target.closest(".close-icon")) return
    if (!dialogRef.current) return
    if (isClickInsideDialog(e, dialogRef.current)) return

    handleCloseModal()
  }

  const closeButtonClickHandler = () => {
    if (!dialogRef.current) return

    handleCloseModal()
  }

  return (
    <Dialog
      onKeyDown={handleKeyDown}
      className="modal"
      ref={dialogRef}
      onClick={dialogClickHandler}
      narrow={employerTile}
    >
      <HeaderBar short={employerTile}>
        <H1 variant="primary" size={employerTile ? "small" : "default"} marginless>
          {header}
        </H1>
        {hasCloseBtn && (
          <CloseIcon
            variant="content"
            size="large"
            style={{ marginRight: "-0.75rem" }}
            onClick={closeButtonClickHandler}
          />
        )}
      </HeaderBar>

      <Content clear={employerTile}>{isOpen && children}</Content>
    </Dialog>
  )
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  hasCloseBtn: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  header: PropTypes.string.isRequired,
  employerTile: PropTypes.bool
}

Modal.defaultProps = {
  hasCloseBtn: true,
  narrow: false
}

export default Modal
